/**
 * Tracking Module - Lightweight event tracking
 * Sends anonymous click events to /api/track-event
 */

const TRACK_URL = '/api/track-event';

const sendEvent = (event) => {
    const payload = JSON.stringify({ event });

    if (navigator.sendBeacon) {
        navigator.sendBeacon(TRACK_URL, new Blob([payload], { type: 'application/json' }));
        return;
    }

    fetch(TRACK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true,
    }).catch(() => {});
};

export const initTracking = () => {
    const phoneBtn = document.querySelector('.floating-phone');

    if (phoneBtn) {
        phoneBtn.addEventListener('click', () => {
            sendEvent('phone-click');
        });
    }
};
